import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, getFormValues, Field } from 'redux-form';
import { flow } from 'lodash';
import './BrokerActivationForm.scss';
import getIncludedResource from '../../../../helpers/getIncludedResource';
import { Form, Row, Col } from 'react-bootstrap';

import { Link } from 'react-router';
import { Icon, Loader, Button } from '../../../../common/components';
import { CheckBoxLabelRight } from '../../../../common/components/ReduxFormField';
import { acceptance } from 'redux-form-validators';
const isAccepted = acceptance({ message: 'Required' });

const FORM_NAME = 'BrokerActivationForm';
class BrokerActivationForm extends Component {
  render() {
    const { agreeBrokerContract, broker, handleSubmit } = this.props;

    if (!broker) {
      return <Loader />;
    }
    const brokerContract = getIncludedResource(
      broker.data,
      broker.included,
      'broker_contracts',
    );

    const tobaPath = brokerContract[0].attributes.file_path;

    const brokerApplication = getIncludedResource(
      broker.data,
      broker.included,
      'broker_application',
    );
    const brokerApplicationDocuments = getIncludedResource(
      brokerApplication.data,
      broker.included,
      'documents',
    );

    const brokerApplicationForm = brokerApplicationDocuments.find((brokerDocument) => {
      return brokerDocument.attributes.document_type === 'Broker Application Form';
    });

    const brokerApplicationFormPath = brokerApplicationForm.attributes.file_path;
    return (
      <div>
        <Form horizontal onSubmit={handleSubmit(agreeBrokerContract)}>
          <Row>
            <Col sm={12}>
              <h1>Hello</h1>
              <p>
                In order to begin working with us, please complete the financial details
                section found on page 3 of your application and return both completed
                documents to us either by post or email to{' '}
                <a href="mailto:brokers@justtravelcover.com">
                  {' '}
                  brokers@justtravelcover.com
                </a>
                .
              </p>

              <div className={'broker-documents'}>
                <p className="broker-document-download">
                  <Link to={tobaPath} target={'_blank'} onlyActiveOnIndex>
                    <Icon name={'file-download'} />
                    <span className={'broker-document-title'}>Terms of Business</span>
                  </Link>
                </p>
                <p className="broker-document-download">
                  <Link
                    to={brokerApplicationFormPath}
                    target={'_blank'}
                    onlyActiveOnIndex
                  >
                    {' '}
                    <Icon name={'file-download'} />
                    <span className={'broker-document-title'}>Application</span>
                  </Link>
                </p>
              </div>

              <div className={'broker-agree-checkboxes'}>
                <Field
                  name={'agree'}
                  component={CheckBoxLabelRight}
                  options={[{ label: '', value: true }]}
                  label="I agree that all details provided within the submitted Application (above) are
                accurate to my knowledge"
                  validate={[isAccepted]}
                />
                <Field
                  name={'adhere'}
                  component={CheckBoxLabelRight}
                  options={[{ label: '', value: true }]}
                  label="I agree that I have read and adhere to the Terms of Business"
                  validate={[isAccepted]}
                />

                <span className="do-not-agree">
                  *If you do not agree, please call us on 0800 458 0466 to discuss your
                  application further.
                </span>
              </div>

              <Button type="submit" bsStyle="primary" label="Activate" />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

export default flow([
  reduxForm({
    form: FORM_NAME,
  }),
  connect((state) => ({
    formValues: getFormValues(FORM_NAME)(state),
    broker: state.brochure.broker,
  })),
])(BrokerActivationForm);
